import local from '../utils/local.js'
import req from '../utils/request.js'
const path = local.getBaseUrl('mall')
const imsPath = local.getBaseUrl('ims')
const authPath = local.getBaseUrl('auth')

/* 获取商品分类列表 */
export function getBlocClassifyList(params) {
  return req.post(`${path}/manage/category/list`, params)
}

/** 当前登录信息接口 */
export function userInfo() {
  return req.get(`${imsPath}/sys/user/info`)
}

/* 获取管理员权限 */
export function queryUserAuthorities() {
  return req.post(`${authPath}/admin/userAuthorities`)
}

/* 获取酒店列表 */
export function getHotelList(params) {
  return req.get(`${imsPath}/cbh/hotelInfo/getHotels`, params)
}
